export default "__VITE_ASSET__DgU7xnab__"